<template>

<com-item name="ratings.publishers" :is-list="true" :has-more="true" v-on:more="onMoreClick" :size="size" :loading="loading" title="Publishers">

	<template v-slot:about>

		<p>Which publishers have received the highest average rating.</p>

	</template>

	<template v-slot:stats>

		<app-person v-for="(item, index) in data" :item="item" type="publisher" :hideCount="true" gamesCountProperty="gamesCount" v-bind:key="index" v-on:more="onPublisherClick(item.id)" />

	</template>

	<template v-slot:buttons>

		<com-toggle :options="publishersOptions" :value="publishersValue" v-on:change="onPublishersChange" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comToggle from './../common/Toggle'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem,
		'com-toggle': comToggle
	},

	computed: {

		publishersOptions: function() {

			var options = []

			options.push({value: this.$CONSTANTS.INSIGHTS.RATINGS.PUBLISHERS.BEST, text: 'Highest average'})
			options.push({value: this.$CONSTANTS.INSIGHTS.RATINGS.PUBLISHERS.MOST, text: 'Most ratings'})

			return options

		},

		publishersValue: function() {

			return this.$store.getters['filter/insights/ratings/publishers']

		},

		loading: function() {

			return this.fetching === 'all' || this.fetching === 'publishers' 

		},

		data: function() {

			return this.$store.getters['page/insights/ratings/publishers']

		},

		active: function() {

			return this.data.length && !this.loading

		}

	},

	methods: {

		onPublishersChange: function(value) {

			this.$store.commit('filter/insights/ratings/publishers', value)

		},

		onMoreClick: function() {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsRatingsPublishers'
			})

		},

		onPublisherClick: function(id) {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsRatingsPublisher',
				id: id
			})

		}
	
	}

}

</script>

<style scoped>

</style>